module.exports = __webpack_public_path__ + "img/0Q3A6289_L_WoodMatted_MockedUp.2f0f6ef5.jpg";